/**
 * Route guard for the authenticated console. Unauthenticated users are
 * redirected to /login (remembering where they were trying to go).
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from './session';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default ProtectedRoute;
